const blobToBase64 = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result?.toString() || '');
    reader.onerror = (error) => reject(error);
  });

export default blobToBase64;

export const stripTypeFromBase64 = (file: string): string => file.split('base64,')[1];



// WEBPACK FOOTER //
// ./src/utils/convertBlobToBase64.ts